import { createSelector } from 'reselect';
import { prsRolloutSelector } from 'ai/selectors/testTarget/prsRollout/prsRolloutSelector';

const showSelector = createSelector(prsRolloutSelector, prsRollout => !!prsRollout.show);

export { showSelector };
